export default "__VITE_ASSET__BzPVrkjD__"